<!-- ═══════════════════ LISTA ═══════════════════ -->
<ng-container *ngIf="content === 'list'">

  <!-- Loading -->
  <div class="qtr-loading" *ngIf="!ready">
    <div class="qtr-loading__dots"><span></span><span></span><span></span></div>
    <p>Cargando justificantes…</p>
  </div>

  <ng-container *ngIf="ready">
    <div class="qtr-page">

      <!-- Cabecera -->
      <app-custom-table-title
        icon="receipt"
        title="Justificantes"
        subTitle="Justificantes de pago de impuestos trimestrales"
        [actions]="[{ label: 'Nuevo justificante', icon: 'add', onClick: create.bind(this) }]">
      </app-custom-table-title>

      <!-- Tabla -->
      <app-table *ngIf="!empty"
        [columns]="headerTable"
        [dataSource]="dataSource"
        [hasButton]="true"
        [actionsTemplate]="actionsButtons"
        [hasHeaderActions]="true"
        [headerActionsTemplate]="headerActionsButtons"
        [hasSelect]="true"
        [hasShowQr]="false"
        [remarkField]="'isIncomplete'"
        [remarkMessage]="'incompleteMessage'"
        [hasMonthFilter]="false"
        [showTotals]="false"
        [showTotalsHasOptionToPay]="false"
        (receiptNumberClick)="onReceiptNumberClick($event)"
        (amountClick)="onAmountClick($event)">
      </app-table>

      <!-- Empty state -->
      <div class="qtr-empty" *ngIf="empty">
        <div class="qtr-empty__art"><mat-icon>receipt</mat-icon></div>
        <h2 class="qtr-empty__title">Sin justificantes</h2>
        <p class="qtr-empty__sub">Todavía no has añadido ningún justificante. Pulsa "Nuevo justificante" para crear uno.</p>
      </div>

    </div>
  </ng-container>

  <!-- Templates acciones -->
  <ng-template #headerActionsButtons let-selected="selected">
    <ul class="custom-class">
      <li (click)="downloadAll(selected)">
        <a><mat-icon>file_download</mat-icon> Descargar justificantes</a>
      </li>
    </ul>
  </ng-template>

  <ng-template #actionsButtons let-uid="uid">
    <ng-container *ngFor="let row of (dataSource | filter : uid : 'uid'); trackBy: trackByIndex">
      <ul class="custom-class">
        <li (click)="edit(uid)">
          <a><mat-icon>edit</mat-icon> Editar</a>
        </li>
        <li (click)="delete(uid)">
          <a><mat-icon>delete</mat-icon> Borrar</a>
        </li>
        <ng-container *ngIf="row.pdf">
          <li (click)="downloadFilePdf(row.uid)">
            <a><mat-icon>attach_file</mat-icon> Documento</a>
          </li>
        </ng-container>
        <li (click)="addManualAccountMovements()">
          <a><mat-icon>show_chart</mat-icon> Contabilizar</a>
        </li>
      </ul>
    </ng-container>
  </ng-template>

</ng-container>


<!-- ═══════════════════ EDITAR / CREAR ═══════════════════ -->
<ng-container *ngIf="content === 'edit'">

  <!-- Loading -->
  <div class="qtr-loading" *ngIf="!ready">
    <div class="qtr-loading__dots"><span></span><span></span><span></span></div>
    <p>Cargando…</p>
  </div>

  <div class="qtr-edit-page" *ngIf="ready">

    <!-- Cabecera -->
    <div class="qtr-edit-header">
      <button mat-icon-button (click)="content = 'list'; getList()" matTooltip="Volver al listado">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div>
        <h1 class="qtr-edit-header__title">{{ model?.uid ? 'Editar justificante' : 'Nuevo justificante' }}</h1>
        <p class="qtr-edit-header__sub">Rellena los datos y adjunta el documento si lo tienes</p>
      </div>
    </div>

    <!-- Tarjeta principal -->
    <div class="qtr-card">
      <div class="qtr-card__head">
        <mat-icon>receipt</mat-icon>
        <span class="qtr-card__head-label">Datos del justificante</span>
      </div>
      <div class="qtr-card__body">
        <div class="qtr-edit-layout">

          <!-- Columna formulario -->
          <div class="qtr-edit-layout__form">

            <div class="qtr-field">
              <label>Número de justificante</label>
              <input type="text" placeholder="Ej: 1111111111111" name="model.receiptNumber" [(ngModel)]="model.receiptNumber">
            </div>

            <div class="qtr-field">
              <label>Ejercicio</label>
              <input type="number" placeholder="Ej: 2025" name="model.taxYear" [(ngModel)]="model.taxYear">
            </div>

            <div class="qtr-field">
              <label>Periodo</label>
              <input type="text" placeholder="Ej: 1T, 01…" name="model.period" [(ngModel)]="model.period">
            </div>

            <div class="qtr-field">
              <label>Modelo</label>
              <input type="text" placeholder="Ej: 111" name="model.taxFormModel" [(ngModel)]="model.taxFormModel">
            </div>

            <div class="qtr-field">
              <label>Importe (€)</label>
              <input type="number" placeholder="0.00" name="model.amount" [(ngModel)]="model.amount">
            </div>

            <div class="qtr-save-bar">
              <button mat-flat-button style="background-color: var(--qtr-brand); color: #fff;"
                (click)="save()"
                [disabled]="quarterTaxReceiptService.saveRequestObservable$ | async">
                <mat-icon>save</mat-icon> Guardar
                <mat-icon class="cf-spin-icon" *ngIf="quarterTaxReceiptService.saveRequestObservable$ | async">autorenew</mat-icon>
              </button>
              <button mat-stroked-button (click)="content = 'list'; getList()">
                Cancelar
              </button>
            </div>

          </div>

          <!-- Columna documento -->
          <div class="qtr-edit-layout__doc">
            <div class="qtr-doc-wrap">

              <app-add-file
                [originEntity]="originEntity"
                [filePath]="filePath"
                [imageTempUrl]="imageTempUrl"
                [showConvfactFiles]="true"
                (CallbackParameters)="SetFileParameters($event)">
              </app-add-file>

              <ng-container *ngIf="readyLoadedFiles === false">
                <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
              </ng-container>

              <ng-container *ngIf="imageTempUrl && model?.pdf">
                <div class="qtr-pdf-preview">
                  <ngx-extended-pdf-viewer [src]="imageTempUrl" [useBrowserLocale]="true"
                    [height]="'100%'" [textLayer]="false">
                  </ngx-extended-pdf-viewer>
                </div>
              </ng-container>

              <ng-container *ngIf="imageTempUrl && !model?.pdf">
                <img [src]="imageTempUrl" class="qtr-img-preview" alt="Documento adjunto">
              </ng-container>

            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</ng-container>
